import { Box, CssBaseline, Grid, Typography, useMediaQuery, useTheme, Card } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import WmsCard from '../../../../../components/WMS/WmsCard';
import { Image } from 'mui-image';
import GaugeChart from 'react-gauge-chart';
import { WmcContext } from '../../../../../context/WmcContext';
import { AuthenticationContext } from '../../../../../context/AuthenticationContext';
import { Constants } from '../../../../../utils/Constants';
import { DATA_TYPE, DT1, DT2, PASS_KEY, WEB_KEY } from '../../../../../api/AxiosApi';
import Barometer from '../../../../../assets/wmsIcon/Barometer';
import BarometerSvg from '../../../../../assets/wmsIcon/BarometerSvg';
import { Font } from 'devextreme-react/cjs/bar-gauge';
import CO2 from '../../../../../assets/wmsIcon/CO2';
import ThermometerSvg from '../../../../../assets/wmsIcon/ThermometerSvg';
import { AppThemeContext } from '../../../../../context/AppThemeContext';

function TransformerHealthTab1() {
    const { PrimaryColor } = useContext(AppThemeContext);
    const { palette, spacing, breakpoints } = useTheme();
    const { WMCDASHDATATrans, getWmcMenuTransForm, WmcLoadingTrans, MenuItems2Trans } = useContext(WmcContext);
    const { LoggedInUserInfo } = useContext(AuthenticationContext);
    const lgs = useMediaQuery(breakpoints.down('lg'));

    const LOGIN_ID = localStorage.getItem('LoginID');
    const LOC_CODE = localStorage.getItem('LCODE');
    const DTYPE = "TRN";


    useEffect(() => {
        // Call immediately on mount
        getWmcMenuTransForm(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, DATA_TYPE, DT1, DT2, DTYPE);

        // Set interval for refreshing every 60 seconds
        const intervalCall = setInterval(() => {
            getWmcMenuTransForm(LOC_CODE, LOGIN_ID, PASS_KEY, WEB_KEY, DATA_TYPE, DT1, DT2, DTYPE);
        }, 60000);

        return () => clearInterval(intervalCall);
    }, []);




    // Sort the data by MENU_INDEX to maintain a consistent order
    const sortedData = WMCDASHDATATrans ? [...WMCDASHDATATrans].sort((a, b) => a?.MENU_INDEX - b?.MENU_INDEX) : [];

    // const matchedMenuItem = MenuItems2.find(menuItem => menuItem?.MENU_NAME === item?.MENU_NAME);





    const filteredData = sortedData.filter(item => !item?.MENU_NAME.includes('-'));

    // console.log("sortedData data trans ", WMCDASHDATATrans)

    return (
        <>
            <CssBaseline />
            <Box bgcolor={'background.default'} py={spacing(1)}>
                <Grid container spacing={spacing(1)}>
                    {WmcLoadingTrans ? (
                        <Typography variant='body2' textAlign={'center'} width={'100%'}>
                            Data Loading........
                        </Typography>
                    ) : sortedData?.length > 0 ? (
                        sortedData.map((item, index) => {
                            const LiveVal = item?.LIVE_VALUE;
                            const MINVAL=item?.min_range
                            const MAXVAL=item?.max_range

                             const normalizedVal = (LiveVal - MINVAL) / (MAXVAL - MINVAL);

                            const matchedMenuItem = MenuItems2Trans.find(menuItem => menuItem?.MENU_NAME === item?.MENU_NAME);

                            return (
                                <Grid key={item?.MENU_INDEX || index} item xs={12} sm={12} md={12} lg={4}>

                                    <WmsCard



                                        // StartIcon={
                                        //     item?.MENU_NAME.startsWith('Solar')
                                        //         ? Constants()['Solar Insolation'] // "Solar Insolation" ka icon use karo
                                        //         : Constants()[item?.MENU_NAME] 
                                        //             ? Constants()[item?.MENU_NAME]
                                        //             : <Image width={70} height={'auto'} src={require('../../../../../assets/img/blank.png')} />
                                        // }

                                        StartIcon={
                                            /^WTI[\s-]?/i.test(item?.MENU_NAME) || /^OTI[\s-]?/i.test(item?.MENU_NAME) ? (
                                                
                                                <ThermometerSvg color={PrimaryColor} height="2.8rem" width="2.8rem" />


                                            ) : item?.MENU_NAME.startsWith('Solar') ? (
                                                Constants()['Solar Insolation']
                                            ) : Constants()[item?.MENU_NAME] ? (
                                                Constants()[item?.MENU_NAME]
                                            ) : (
                                                <Image width={70} height={'auto'} src={require('../../../../../assets/img/blank.png')} />
                                            )
                                        }




                                        WmsCardStyle={{ flex: 1, height: '100%' }}
                                        title={`${item?.MENU_NAME} ${matchedMenuItem?.SH_NAME_LOG || ''}`}


                                        boldTitle={
                                            item?.MENU_NAME === 'Solar Insolation'
                                                ? `${item?.['Solar Insolation']} ${item?.UNIT}`
                                                : item?.LIVE_VALUE
                                                    ? `${item?.LIVE_VALUE} ${item?.UNIT}`
                                                    : '____'
                                        }
                                        LiveDate={
                                            item?.MENU_NAME === 'Solar Insolation'
                                                ? item?.['Date']
                                                : item?.LIVE_DATE_TIME
                                                    ? item?.LIVE_DATE_TIME
                                                    : '____'
                                        }
                                        rightTitle={
                                            item?.MENU_NAME === 'Solar Insolation' || item?.MENU_NAME === 'Wind Direction'
                                                ? null
                                                : item?.UD
                                        }
                                        minValue={
                                            item?.MENU_NAME === 'Solar Insolation' || item?.MENU_NAME === 'Wind Direction'
                                                ? null
                                                : item?.MIN_VALUE || '____'
                                        }
                                        maxValue={
                                            item?.MENU_NAME === 'Solar Insolation' || item?.MENU_NAME === 'Wind Direction'
                                                ? null
                                                : item?.MAX_VALUE || '____'
                                        }
                                        avgValue={
                                            item?.MENU_NAME === 'Solar Insolation' || item?.MENU_NAME === 'Wind Direction'
                                                ? null
                                                : item?.AVG_VALUE || '____'
                                        }
                                        tempMeters={
                                            <Box>
                                                <GaugeChart
                                                    id="gauge-chart5"
                                                    nrOfLevels={420}
                                                    arcsLength={[0.3, 0.5, 0.2]}
                                                    colors={['#FED7AA', '#FB923C', '#EA580C']}
                                                    percent={normalizedVal}
                                                    textColor={palette.primary.dark}
                                                    cornerRadius={0}
                                                    hideText
                                                    animate={false}
                                                    style={{ width: '7rem', margin: 'auto' }}
                                                    arcPadding={0.0}
                                                />
                                                <Typography
                                                    noWrap
                                                    component={Card}
                                                    bgcolor={palette.primary.light}
                                                    width={'5rem'}
                                                    m={'auto'}
                                                    textAlign={'center'}
                                                    variant='body1'>
                                                    {item?.MENU_NAME === 'Solar Insolation'
                                                        ? `${item?.['Solar Insolation']} ${item?.UNIT}`
                                                        : LiveVal
                                                            ? `${LiveVal} ${item?.UNIT}`
                                                            : '____'}
                                                </Typography>
                                            </Box>
                                        }
                                    />


                                </Grid>
                            );
                        })
                    ) : (
                        <Typography variant='body2' width={'100%'} textAlign={'center'}>
                            Data not found
                        </Typography>
                    )}
                </Grid>
            </Box>
        </>
    );
}

export default TransformerHealthTab1